import { render, staticRenderFns } from "./BudgetGuardCodeBudgets.vue?vue&type=template&id=2c401184"
import script from "./BudgetGuardCodeBudgets.vue?vue&type=script&lang=ts"
export * from "./BudgetGuardCodeBudgets.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports